import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext(null);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = cargando, false = no autenticado, objeto = autenticado
  const [loading, setLoading] = useState(true);

  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem("cortoviral_token");
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const res = await axios.get(`${API}/auth/me`, {
        headers,
        withCredentials: true
      });
      setUser(res.data);
    } catch (err) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    if (res.data?.token) {
      localStorage.setItem("cortoviral_token", res.data.token);
    }
    setUser(res.data.user);
    fetchProfile(); // perfil completo (precio, email de PayPal, motor de IA...)
    return res.data;
  };

  const register = async (email, password, name) => {
    // Obtener token anti-abuso previo
    let client_token = null;
    try {
      const antiRes = await axios.get(`${API}/auth/anti-abuse-token`);
      client_token = antiRes.data?.token;
    } catch (e) {
      console.warn("Anti abuse token not available, continuing");
    }

    const res = await axios.post(
      `${API}/auth/register`,
      { email, password, name, client_token },
      { withCredentials: true }
    );
    if (res.data?.token) {
      localStorage.setItem("cortoviral_token", res.data.token);
    }
    setUser(res.data.user);
    fetchProfile(); // perfil completo (precio, email de PayPal, motor de IA...)
    return res.data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (e) {}
    localStorage.removeItem("cortoviral_token");
    setUser(false);
  };

  const refreshUser = async () => {
    await fetchProfile();
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
